import { AlertTriangle, Bot, ClipboardPaste, Timer } from "lucide-react";

const LEVELS = {
  high: { label: "High AI risk", cls: "bg-rose-50 border-rose-200 text-rose-800", pill: "bg-rose-600 text-white" },
  medium: { label: "Medium AI risk", cls: "bg-amber-50 border-amber-200 text-amber-900", pill: "bg-amber-500 text-white" },
  low: { label: "Low AI risk", cls: "bg-emerald-50 border-emerald-200 text-emerald-900", pill: "bg-emerald-600 text-white" },
};

const levelFor = (ai) => ai.risk_level || (ai.final_score >= 55 ? "high" : ai.final_score >= 30 ? "medium" : "low");

const BehaviourLine = ({ b }) => {
  if (!b || b.paste_pct == null) return <p className="text-[11px] opacity-70" data-testid="ai-behaviour-none">No writing-behaviour data for this answer (submitted before tracking was added).</p>;
  return (
    <p className="flex flex-wrap items-center gap-x-3 gap-y-1 text-[11px]" data-testid="ai-behaviour">
      <span className="inline-flex items-center gap-1"><ClipboardPaste size={11} /> {b.paste_pct}% pasted{b.paste_events ? ` (${b.paste_events} paste${b.paste_events === 1 ? "" : "s"})` : ""}</span>
      <span className="inline-flex items-center gap-1"><Timer size={11} /> {b.active_seconds ? `${b.active_seconds}s writing` : "no typing time recorded"}{b.wpm ? ` · ${b.wpm} words/min` : ""}</span>
    </p>
  );
};

export const AiRiskPanel = ({ ai, idx }) => {
  if (!ai) return null;
  const lvl = LEVELS[levelFor(ai)];
  return (
    <div className={`space-y-1.5 rounded-lg border p-2.5 ${lvl.cls}`} data-testid={`ai-risk-panel-${idx}`}>
      <div className="flex items-center gap-2">
        <span className={`inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[11px] font-semibold ${lvl.pill}`} data-testid={`ai-risk-level-${idx}`}>
          <AlertTriangle size={11} /> {lvl.label}
        </span>
        <span className="text-[11px] opacity-80" data-testid={`ai-risk-score-${idx}`}>
          Score {ai.final_score}/100 · style {ai.heuristic_score}{ai.llm_score != null ? ` · AI model ${ai.llm_score}` : ""}{ai.llm_samples?.length > 1 ? ` (${ai.llm_samples.join("/")})` : ""}{ai.similarity_score != null ? ` · ChatGPT match ${ai.similarity_score}` : ""}
        </span>
      </div>
      {ai.llm_reason && <p className="flex items-start gap-1 text-[11px]" data-testid={`ai-llm-reason-${idx}`}><Bot size={12} className="mt-px shrink-0" /> {ai.llm_reason}</p>}
      {ai.reasons?.length > 0 && (
        <ul className="list-disc pl-4 text-[11px]" data-testid={`ai-reasons-${idx}`}>{ai.reasons.map((r) => <li key={r}>{r}</li>)}</ul>
      )}
      <BehaviourLine b={ai.behaviour} />
    </div>
  );
};
